import {combineReducers} from 'redux'

import GlobalReducer from './GlobalReducer';
import FullProfileReducer from './FullProfileReducer';
import AuthReducer from "./AuthReducer";
import TalentSearchReducer from "./TalentSearch/TalentSearchReducer";
import WatchlistReducer from './Watchlist/WatchlistReducer';

const RootReducer = combineReducers({
    global: GlobalReducer,
    full_profile: FullProfileReducer, // TODO: convert to camelCase
    talentSearch: TalentSearchReducer,
    watchlist: WatchlistReducer,
    auth: AuthReducer,
});

export default RootReducer;
